import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'masterPlanType',
  pure: true, // Improves performance
  standalone: true,
})
export class MasterPlanTypePipe implements PipeTransform {
   transform(type: number): string {
    switch (type) {
      case 1: return 'LD Planning';
      case 2: return 'HD Planning';
      default: return 'Unknown';
    }
  }
}
